import { render, staticRenderFns } from "./SidebarNavDivider.vue?vue&type=template&id=9afd337c&scoped=true"
import script from "./SidebarNavDivider.ts?vue&type=script&lang=ts&external"
export * from "./SidebarNavDivider.ts?vue&type=script&lang=ts&external"
import style0 from "./SidebarNavDivider.vue?vue&type=style&index=0&id=9afd337c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afd337c",
  null
  
)

export default component.exports